<template>
  <abf-container>
    <v-layout wrap>
      <v-flex xs12 md5>
        <v-card class="pa-2">
          <v-card-title class="pb-0 mb-0">
            <v-avatar class="secondary">
              <v-icon dark>create</v-icon>
            </v-avatar>
            <div class="ml-3">
              <h4 class="headline">Content</h4>
            </div>
          </v-card-title>
          <v-form lazy-validation>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md12>
                  <image-edit-upload :url.sync="updates.logo" :path="'partner-images'"></image-edit-upload>
                </v-flex>
                <v-flex xs12 sm6 md12>
                  <v-text-field label="Comms Headline" v-model="updates.headline"></v-text-field>
                  <v-text-field label="Comms Link" v-model="updates.link"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-subheader class="pa-0">Comms Content</v-subheader>
                  <vue-editor id="comms" v-model="updates.content" :editorToolbar="toolbarOptions"></vue-editor>
                </v-flex>
                <v-flex xs12 sm3 v-if="UserHasRole('Platform')">
                  <v-switch label="Enabled" v-model="updates.enabled"></v-switch>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="accent" @click="updatePartner">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 md7>
        <v-card class="pa-2">
          <v-card-title class="pb-0 mb-0">
            <v-avatar class="secondary">
              <v-icon dark>email</v-icon>
            </v-avatar>
            <div class="ml-3">
              <h4 class="headline">Email Preview</h4>
            </div>
          </v-card-title>
          <v-card-text class="pa-3 pt-4">
            <h2>{{ SelectedPartner.name }}</h2>
            <v-layout pt2>
              <v-flex>
                <img alt="partner logo" :src="SelectedPartner.logo" style="width: 190px; height: auto;" />
              </v-flex>
              <v-flex>
                <span class="partner-web-content" v-html="updates.content"></span>
              </v-flex>
            </v-layout>
            <p style="clear: both; text-align: center;">
              <a class="success updates-link" :href="updates.link" target="_blank" title="Find out more">
                Find out more
              </a>
            </p>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </abf-container>
</template>

<script>
import _ from 'lodash';
import { VueEditor } from 'vue2-editor';
import { mapActions, mapGetters } from 'vuex';
import ImageEditUpload from './ImageEditUpload';
import AbfContainer from '../../Abf/AbfContainer';
import { toolbarOptions } from '@/utils/vueEditorConfig';

export default {
  components: {
    AbfContainer,
    VueEditor,
    ImageEditUpload
  },
  name: 'partner-comms-content',
  data: () => ({
    toolbarOptions,
    updates: {
      id: null,
      business_id: null,
      headline: null,
      content: '',
      link: null,
      logo: null,
      enabled: false
    }
  }),
  computed: {
    ...mapGetters(['SelectedPartner', 'UserHasRole'])
  },
  methods: {
    ...mapActions(['updatePartnerCampaign', 'addPartnerCampaign', 'addNotification']),
    updatePartner: function() {
      if (_.isNull(this.updates.id)) {
        const newUpdates = _.omit(this.updates, 'id');
        this.addPartnerCampaign(newUpdates).then(() => {
          this.addNotification({
            text: `${this.SelectedPartner.name} email campaign added`
          });
        });
      } else {
        this.updatePartnerCampaign(this.updates).then(() => {
          this.addNotification({
            text: `${this.SelectedPartner.name} email campaign updated`
          });
        });
      }
    }
  },
  watch: {
    SelectedPartner: {
      immediate: true,
      handler() {
        this.updates.business_id = this.SelectedPartner.id;
        if (!_.isEmpty(this.SelectedPartner.campaigns)) {
          this.updates.id = this.SelectedPartner.campaigns[0].id;
          this.updates.headline = this.SelectedPartner.campaigns[0].headline;
          this.updates.logo = this.SelectedPartner.campaigns[0].logo;
          this.updates.link = this.SelectedPartner.campaigns[0].link;
          this.updates.content = this.SelectedPartner.campaigns[0].content;
          this.updates.enabled = this.SelectedPartner.campaigns[0].enabled;
        }
      }
    }
  }
};
</script>

<style scoped>
.updates-link {
  background-color: #89c731;
  border-radius: 3px;
  color: #ffffff;
  display: inline-block;
  font-weight: bold;
  letter-spacing: normal;
  line-height: 100%;
  padding: 10px;
  text-align: center;
  text-decoration: none;
}
</style>
